import {useEffect, useState} from "react";
import {apiGetMoodsToday, apiSubmitMood} from "../api/moods";

export function useMoodToday(groupId) {
    const [data, setData] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const [justVoted, setJustVoted] = useState(false);
    const [voteError, setVoteError] = useState(null);

    useEffect(() => {
        if (groupId) {
            apiGetMoodsToday(groupId).then(setData);
        }
    }, [groupId]);

    async function vote(level) {
        if (submitting || data?.userMood) return;
        setSubmitting(true);
        setVoteError(null);
        const result = await apiSubmitMood(groupId, level);
        if (!result.error) {
            setJustVoted(true);
        } else {
            setVoteError(result.error);
        }
        const refreshed = await apiGetMoodsToday(groupId);
        setData(refreshed);
        setSubmitting(false);
    }

    return {data, submitting, justVoted, voteError, vote};
}
